export const userClickGladyChatButton = ({ path }) => ({
  type: 'Glady widget opened',
  data: { path },
});
